import "./template2.css";
import React from "react";
import { mySort } from "../../../utils/general";
import { sanitizeRichText } from "../../../utils/richTextSanitizer";
import WhatsappFloatComponent from "components/comun/whatsapp";
import { useLocation, useSearchParams } from "react-router-dom";
import LegadosContactoComponent from "./legados-contacto";
import LegadosBannerComponent from "./legados-banner";
import LegadosContenidoEstaticoComponent from "./legados-contenido-estatico";

const Template2Component = ({ children }) => {
  const [body, setBody] = React.useState();
  const [sidemenu, setSidemenu] = React.useState([]);

  const location = useLocation();
  const [searchParams] = useSearchParams();

  const allowIframe = (content) => sanitizeRichText(content);

  React.useEffect(() => {
    window.scrollTo({ top: 0 });

    const sidemenu = [...children.template2.sidemenu];
    mySort(sidemenu, "order");

    // Deep-link: si viene ?seccion=legados en la URL, seleccionar esa pestaña
    // en vez de la primera por defecto.
    const seccion = searchParams.get("seccion");
    let initialBody = sidemenu[0];
    if (seccion) {
      const found = sidemenu.find(
        (item) => item.nombre?.trim().toLowerCase() === seccion.trim().toLowerCase()
      );
      if (found) initialBody = found;
    }

    setBody(initialBody);
    setSidemenu(sidemenu);
  }, [children]);

  React.useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const sectionBackgroundImage = {
    background: `url("${children?.template2?.fondo?.url}")`,
    // backgroundSize: 'cover',
    backgroundColor: "#dedbd9",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    backgroundPosition: "center",
    height: "100%",
    backgroundAttachment: "fixed",
  };

  return (
    <section style={sectionBackgroundImage}>
      {location.pathname=="/pages/recaudacion-de-fondos-1"&&<WhatsappFloatComponent href={"https://wa.me/5491171239251"}  />}
      <div className="container-lg pb-5">
        <div className="row pt-5">
          <div className="col-md-3 col-lg-3">
            <div className="d-flex flex-column justify-content-center">
              {children.nombre.length < 14 ? (
                <h2 className="internacion__titulo2 mb-4">{children.nombre}</h2>
              ) : (
                <h2 className="internacion__titulo mb-4">{children.nombre}</h2>
              )}
              <div className="d-flex flex-column mb-4">
                {sidemenu.map((data, index) => {
                  const handleClick = () => {
                    setBody(data);
                    if (data.nombre?.trim().toLowerCase() === "legados") {
                      window.open(`${location.pathname}?seccion=legados`, "_blank");
                    }
                  };

                  return (
                    <button
                      type="button"
                      key={index}
                      className="btn grandiend-btn my-1"
                      onClick={handleClick}
                    >
                      {data.nombre}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-md-9 col-lg-9">
            {body && (
              <>
                <div className="card p-4 b-radius-10">
                  <h2 style={{ color: "#05294F" }}>{body.nombre}</h2>
                  <hr />
                  {body.nombre?.trim().toLowerCase() === "legados" && (
                    <LegadosBannerComponent />
                  )}
                  {body.nombre?.trim().toLowerCase() === "legados" ? (
                    // TEMPORAL (PBI 25179): el contenido de "Legados" en este
                    // CMS está desactualizado respecto a producción. Mientras
                    // se sincroniza, se muestra una copia estática exacta de
                    // producción. Sacar este bloque y volver a habilitar el
                    // de abajo (dinámico) en cuanto el contenido esté al día.
                    // El formulario se pasa como children para que quede
                    // ubicado entre los bullets y "Conocé la historia...".
                    <LegadosContenidoEstaticoComponent>
                      <LegadosContactoComponent />
                    </LegadosContenidoEstaticoComponent>
                  ) : (
                    <div className="contenido">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: allowIframe(body.contenido),
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Template2Component;
